// Each environment's config lives in its own file (environments.prod.js,
// environments.dev.js). The active bundle is selected at build time by
// REACT_APP_APPLI_ENV (set in .env.local, defaults to "prod").
//
// CRA inlines the env var at build time, so only the selected config's
// import survives dead-code elimination — the other environment's values
// never ship in the production bundle.
import devConfig from './environments.dev';
import prodConfig from './environments.prod';

const APPLI_ENV = process.env.REACT_APP_APPLI_ENV || "prod";

const env = APPLI_ENV === "dev" ? devConfig : prodConfig;

export default env;
export const APPLI_ENV_NAME = APPLI_ENV;
